/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import logo from './images/logo.png';
import prePRDLabel from './images/pre-prd-pill.svg';
import Hamburger from './components/Hamburger/';
import HeaderDropDown from './components/HeaderDropDown/';
import PeopleSearcher from './components/PeopleSearcher/';
import './style.css';
import { url } from 'configs/';
import { withPermission, Can } from '@mayo/user-permissions';
import moduleConfig from './modules';
import defaultPicture from 'images/unknown.png';
import { FormattedMessage } from 'react-intl';
import AngleDownIconCmp from './components/AngleDownIcon';
import GlobeIconCmp from './components/GlobeIcon';
import KeyIconCmp from './components/KeyIcon';
import UserIcomCmp from './components/UserIcon';
import PowerOffIconCmp from './components/PowerOffIcon';
import PreferenceIcon from './components/PreferenceIcon';
import tbdFlags from 'utils/tbdFlags';
import Dialog from 'componentsv3/Dialog';
import {
  FIDO_TERMS,
  FIDO_RESULT_STATUS,
  FIDO_RESULT_MESSAGES_ID,
  FIDO_RESULT_TITLE_ID,
} from 'constant/fido';
import fido2RegistrationService from 'utils/fido2RegistrationService';
import TokenCountdown from './components/TokenCountdown';

// 基本的權限配置
const permissionConfig = {
  permission: 'PeopleSearchHeader',
  functionCodes: [
    { functionCode: 'PeopleSearch', actionCode: 'Default' },
    { functionCode: 'ChangePassword', actionCode: 'Default' },
    { functionCode: 'FIDOSwitchWeb', actionCode: 'Default' },
  ],
  baseURL: url.NEWTUBE_API_SERVER,
};

class Header extends Component {
  constructor() {
    super();
    this.state = {
      searchFocused: false,
      avatarHovered: false,
      isUserMenuVisible: false,
      isLanguangeMenuVisible: false,
      currentNavigationItemElement: null,
      currentNavigationItemInfo: {},
      activeBarStyle: {},
      isUserNameOutOfRange: null,
      isRegistered: this.checkFIDORegistrationStatus(),
      shouldShowFIDO2Modal: false,
      shouldShowFIDO2ResultModal: false,
      fido2ResultMessageId: '',
      fido2ResultTitleId: '',
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.handleSearchFocus = this.handleSearchFocus.bind(this);
    this.handleAvatarHover = this.handleAvatarHover.bind(this);
    this.onUserMunuVisible = this.onUserMunuVisible.bind(this);
    this.onLanguangeMenuVisible = this.onLanguangeMenuVisible.bind(this);
    this.onNavItemMouseIn = this.onNavItemMouseIn.bind(this);
    this.onNavItemMouseOut = this.onNavItemMouseOut.bind(this);
    this.onSwitchLocale = this.onSwitchLocale.bind(this);
    this.handleRegisterFIDO2 = this.handleRegisterFIDO2.bind(this);
    this.handleToggleFIDO2Modal = this.handleToggleFIDO2Modal.bind(this);
    this.checkFIDORegistrationStatus =
      this.checkFIDORegistrationStatus.bind(this);
    this.forceUpdateFIDOStatus = this.forceUpdateFIDOStatus.bind(this);
    this.handleRegisterFIDO2Success =
      this.handleRegisterFIDO2Success.bind(this);
    this.navigationItemRef = [];
  }

  componentDidMount() {
    this.setCurrentNavigationItemElement();
    this.checkIsUserNameOutOfRange();

    // 檢查初始 FIDO 註冊狀態
    this.updateFIDORegistrationStatus();
  }

  componentDidUpdate(prevProps, prevState) {
    var isSmallScreen = this.props.isSmallScreen;
    const { currentNavigationItemInfo, currentNavigationItemElement } =
      this.state;
    const isMenuNotHidden = !prevState.searchFocused;
    const isActiveItemUpdated =
      currentNavigationItemElement &&
      (currentNavigationItemInfo.left !==
        currentNavigationItemElement.offsetLeft ||
        currentNavigationItemInfo.width !==
          currentNavigationItemElement.offsetWidth);

    if (isMenuNotHidden && isActiveItemUpdated) {
      const style = {
        left: currentNavigationItemElement.offsetLeft,
        width: currentNavigationItemElement.offsetWidth,
      };
      /* eslint-disable react/no-did-update-set-state */
      this.setState({
        currentNavigationItemInfo: style,
        activeBarStyle: style,
      });
    } else if (!currentNavigationItemElement) {
      this.setCurrentNavigationItemElement();
    }
    if (
      prevProps.isSmallScreen !== isSmallScreen ||
      prevState.isUserNameOutOfRange === null
    ) {
      this.checkIsUserNameOutOfRange();
    }
  }

  onNavItemMouseIn(idx) {
    try {
      const elem = this.navigationItemRef[idx];
      if (
        elem &&
        elem.offsetLeft !== undefined &&
        elem.offsetWidth !== undefined
      ) {
        const style = {
          left: elem.offsetLeft,
          width: elem.offsetWidth,
        };
        this.setState({ activeBarStyle: style });
      } else if (
        this.state.currentNavigationItemElement &&
        this.state.currentNavigationItemElement.offsetLeft !== undefined &&
        this.state.currentNavigationItemElement.offsetWidth !== undefined
      ) {
        const style = {
          left: this.state.currentNavigationItemElement.offsetLeft,
          width: this.state.currentNavigationItemElement.offsetWidth,
        };
        this.setState({ activeBarStyle: style });
      }
    } catch (error) {
      console.warn('onNavItemMouseIn 錯誤:', error);
    }
  }

  onNavItemMouseOut() {
    try {
      if (
        this.state.currentNavigationItemElement &&
        this.state.currentNavigationItemElement.offsetLeft !== undefined &&
        this.state.currentNavigationItemElement.offsetWidth !== undefined
      ) {
        const style = {
          left: this.state.currentNavigationItemElement.offsetLeft,
          width: this.state.currentNavigationItemElement.offsetWidth,
        };
        this.setState({ activeBarStyle: style });
      }
    } catch (error) {
      console.warn('onNavItemMouseOut 錯誤:', error);
    }
  }

  onUserMunuVisible(isUserMenuVisible) {
    this.setState({ isUserMenuVisible });
  }

  onLanguangeMenuVisible(e) {
    e.preventDefault();
    this.setState((prev) => ({
      isLanguangeMenuVisible: !prev.isLanguangeMenuVisible,
    }));
  }

  onSwitchLocale(e) {
    const langCode = e.target.dataset.code;
    if (this.props.onSwitchLocale) {
      this.props.onSwitchLocale(langCode);
    }
  }
  setCurrentNavigationItemElement() {
    try {
      const { moduleAuth } = this.props;
      const modules = moduleConfig.filter(
        (m) => moduleAuth && moduleAuth.indexOf(m.authKey) > -1
      );
      for (let i = 0; i < modules.length; i++) {
        if (
          window.location.pathname.startsWith(modules[i].activePath) &&
          this.navigationItemRef[i]
        ) {
          const elem = this.navigationItemRef[i];
          if (elem && elem.offsetWidth !== undefined) {
            /* eslint-disable react/no-did-mount-set-state */
            this.setState({
              currentNavigationItemElement: this.navigationItemRef[i],
            });
          }
          break;
        }
      }
    } catch (error) {
      console.warn('setCurrentNavigationItemElement 錯誤:', error);
    }
  }
  checkIsUserNameOutOfRange() {
    try {
      if (
        this.refs.userNameRef &&
        this.refs.userNameRef.offsetWidth !== undefined
      ) {
        this.setState({
          isUserNameOutOfRange: this.refs.userNameRef.offsetWidth > 660,
        });
      }
    } catch (error) {
      console.warn('checkIsUserNameOutOfRange 錯誤:', error);
    }
  }
  handleSearchFocus() {
    this.setState((prev) => ({ searchFocused: !prev.searchFocused }));
  }

  handleAvatarHover() {
    this.setState((prev) => ({ avatarHovered: !prev.avatarHovered }));
  }

  handleLogout(e) {
    e.preventDefault();
    const { onLogout } = this.props;
    if (onLogout && typeof onLogout === 'function') {
      onLogout();
    }
  }

  // 檢查 FIDO 註冊狀態
  checkFIDORegistrationStatus() {
    try {
      var fido2RegisterStatus = localStorage.getItem('isFido2Registered');
      return fido2RegisterStatus === 'true';
    } catch (error) {
      return false;
    }
  }

  // 更新 FIDO 註冊狀態
  updateFIDORegistrationStatus() {
    var currentStatus = this.checkFIDORegistrationStatus();
    if (this.state.isRegistered !== currentStatus) {
      this.setState({ isRegistered: currentStatus });
    }
  }

  // 強制更新 FIDO 狀態
  forceUpdateFIDOStatus() {
    var shouldBeRegistered = this.checkFIDORegistrationStatus();
    this.setState({ isRegistered: shouldBeRegistered });
    return shouldBeRegistered;
  }

  handleRegisterFIDO2() {
    var self = this;

    if (
      !fido2RegistrationService ||
      typeof fido2RegistrationService.executeRegistration !== 'function'
    ) {
      console.error('FIDO2 服務未正確初始化');
      return;
    }

    // console.log('fido2RegistrationService running...');
    // 使用 bind 確保 this 上下文正確
    fido2RegistrationService.executeRegistration.bind(fido2RegistrationService)(
      this.props.companyCode,
      this.props.employeeNumber,
      function (error, result) {
        // 如果有錯誤但沒有 result，表示流程未完成，不顯示模態框
        if (error && !result) {
          console.error('FIDO2 註冊流程錯誤:', error);
          return;
        }

        // 檢查是否已註冊
        if (result && result.isRegistered) {
          self.handleRegisterFIDO2Success();
          return;
        }

        // 只有當流程完成時才顯示模態框
        if (result && result.success) {
          // 註冊成功
          var status = FIDO_RESULT_STATUS[String(result.code)] || 'success';
          self.setState({
            shouldShowFIDO2ResultModal: true,
            fido2ResultMessageId:
              FIDO_RESULT_MESSAGES_ID[status] || 'SH_Fido_RegisterSuccess',
            fido2ResultTitleId:
              FIDO_RESULT_TITLE_ID[status] || 'SH_Fido_RegisterSuccess',
          });

          // 註冊成功後，將狀態存入 localStorage
          self.handleRegisterFIDO2Success();
        } else {
          // 註冊失敗
          var status = FIDO_RESULT_STATUS[String(result.code)] || 'fail';
          self.setState({
            shouldShowFIDO2ResultModal: true,
            fido2ResultMessageId:
              FIDO_RESULT_MESSAGES_ID[status] || 'SH_Fido_RegisterDisabled',
            fido2ResultTitleId:
              FIDO_RESULT_TITLE_ID[status] || 'SH_Fido_RegisterFail',
          });
        }
      }
    );
  }

  handleToggleFIDO2Modal() {
    this.setState({
      shouldShowFIDO2Modal: !this.state.shouldShowFIDO2Modal,
    });
  }
  handleRegisterFIDO2Success() {
    localStorage.setItem('isFido2Registered', 'true');
    window.location.reload();
  }

  render() {
    const {
      activeBarStyle,
      searchFocused,
      avatarHovered,
      isUserMenuVisible,
      isLanguangeMenuVisible,
      isUserNameOutOfRange,
    } = this.state;
    const {
      isLoggedIn,
      isSmallScreen,
      userName,
      companyLogo,
      personalPicture,
      permission,
      primaryColor,
      locales,
      locale,
      handleToggleSidebar,
      moduleAuth,
      isSidebarDisplay,
    } = this.props;
    const isPrePRD = location.hostname.indexOf('pre') === 0;
    const modules = moduleConfig.filter(
      (m) => moduleAuth && moduleAuth.indexOf(m.authKey) > -1
    );
    const dropdownToggle = (
      <div
        className="apollo-user-info"
        onMouseEnter={this.handleAvatarHover}
        onMouseLeave={this.handleAvatarHover}
      >
        <div className="apollo-user-avatar-container apollo-user-avatar">
          <div
            className="apollo-user-avatar"
            style={{
              color:
                avatarHovered || isUserMenuVisible
                  ? primaryColor
                  : 'transparent',
            }}
          >
            <div
              style={{
                height: '35px',
                backgroundImage: `url(${personalPicture || defaultPicture})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
              }}
            ></div>
          </div>
          {permission.isActionAllowed(['FIDOSwitchWeb'], 'Default') && 
           !this.state.isRegistered && (
            <div className="apollo-user-avatar-registered"></div>
          )}
        </div>
        {!isSmallScreen && !isUserNameOutOfRange && (
          <span ref="userNameRef">
            <FormattedMessage
              id="SH_Welcome"
              defaultMessage="歡迎, {0}"
              values={{
                0: userName,
              }}
            />
          </span>
        )}
      </div>
    );

    return (
      <header className="apollo-header">
        <div className="apollo-header-row space-between">
          <div className="apollo-header-row">
            {isSmallScreen && isSidebarDisplay && (
              <Hamburger onClick={handleToggleSidebar} />
            )}
            <div className="apollo-header-logo">
              <a href="/tube" onClick={this.props.onLinkClick}>
                <img src={companyLogo || logo} />
              </a>
            </div>
            {isPrePRD && (
              <div id="preprd-label">
                <img src={prePRDLabel} />
              </div>
            )}
            <ul
              className={`apollo-header-navigation ${
                searchFocused && isSmallScreen ? 'push-to-left' : ''
              }`}
            >
              {modules.map((m, idx) => {
                return (
                  <li
                    key={m.displayName}
                    className={`apollo-header-navigation-item ${
                      location.pathname
                        .toLowerCase()
                        .indexOf(m.activePath.toLowerCase()) === 0
                        ? 'active'
                        : ''
                    }`}
                    onMouseEnter={() => this.onNavItemMouseIn(idx)}
                    onMouseLeave={this.onNavItemMouseOut}
                    ref={(ref) => (this.navigationItemRef[idx] = ref)}
                  >
                    <a href={m.linkPath || m.activePath}>
                      <FormattedMessage
                        id={m.i18Key}
                        defaultMessage={m.displayName}
                      />
                    </a>
                  </li>
                );
              })}
              <li
                key="navigation-bar"
                className="apollo-header-navigation-bar"
                style={{
                  width: activeBarStyle.width,
                  left: activeBarStyle.left,
                  backgroundColor: primaryColor,
                }}
              />
            </ul>
          </div>
          {isLoggedIn && (
            <div className="apollo-header-row">
              {/* OPTI-38 UAT-only：token 剩餘時間倒數（< 60 分才出現；續期自動重數） */}
              <TokenCountdown />
              <Can
                on="PeopleSearch"
                run="Default"
                render={() => {
                  return (
                    <PeopleSearcher
                      history={this.props.history}
                      handleSearchFocus={this.handleSearchFocus}
                    />
                  );
                }}
              />
              <HeaderDropDown
                title={dropdownToggle}
                onVisibleChange={this.onUserMunuVisible}
              >
                {(isSmallScreen || isUserNameOutOfRange) && (
                  <li className="apollo-header-menu-username">{userName}</li>
                )}
                <li className="apollo-header-menu-item">
                  <a href="/foundation/mydata">
                    <span className="apollo-header-menu-icon">
                      <UserIcomCmp />
                    </span>
                    <FormattedMessage
                      id="SH_MyData"
                      defaultMessage="個人資訊"
                    />
                  </a>
                </li>

                {/* 註冊 FIDO2 */}
                {permission.isActionAllowed(['FIDOSwitchWeb'], 'Default') && (
                  <li className="apollo-header-menu-item">
                    {/* Tag */}
                    {!this.state.isRegistered ? (
                      <a onClick={this.handleToggleFIDO2Modal}>
                        <div className="apollo-header-menu-item-content">
                          <span className="apollo-header-menu-icon">
                            <img
                              src={require('./images/fido.svg')}
                              alt="FIDO"
                            />
                          </span>
                          <div className="apollo-header-menu-item-content-text">
                            <FormattedMessage
                              id="SH_RegisterFIDO2"
                              defaultMessage="FIDO 快速登入註冊"
                            />
                            <div className="apollo-header-menu-tag">
                              <span className="apollo-header-menu-tag-text">
                                New
                              </span>
                            </div>
                          </div>
                        </div>
                      </a>
                    ) : (
                      <a>
                        <div className="apollo-header-menu-item-content">
                          <span className="apollo-header-menu-icon">
                            <img
                              src={require('./images/fido.svg')}
                              alt="FIDO"
                            />
                          </span>
                          <div className="apollo-header-menu-item-content-text fido-registered-text">
                            <FormattedMessage
                              id="SH_Fido_Web_Reg"
                              defaultMessage="FIDO 快速登入"
                            />
                            <span className="apollo-header-menu-icon">
                              <img
                                src={require('./images/fido-registered.svg')}
                                alt="FIDO Registered"
                              />
                            </span>
                          </div>
                        </div>
                      </a>
                    )}
                  </li>
                )}
                {permission.isActionAllowed(['ChangePassword'], 'Default') && (
                  <li className="apollo-header-menu-item">
                    <a href="/tube/accountsetting">
                      <span className="apollo-header-menu-icon">
                        <KeyIconCmp />
                      </span>
                      <FormattedMessage
                        id="SH_ChangePassword"
                        defaultMessage="修改密碼"
                      />
                    </a>
                  </li>
                )}
                <li
                  className={`apollo-header-menu-item ${
                    isLanguangeMenuVisible ? 'open' : ''
                  }`}
                >
                  <a href="#" onClick={this.onLanguangeMenuVisible}>
                    <span className="apollo-header-menu-icon">
                      <GlobeIconCmp />
                    </span>
                    <FormattedMessage
                      id="SH_LanguageFamily"
                      defaultMessage="語系"
                    />
                    <span
                      className={`apollo-header-menu-icon ${
                        isLanguangeMenuVisible ? 'active' : ''
                      }`}
                      style={{ float: 'right' }}
                    >
                      <AngleDownIconCmp />
                    </span>
                  </a>
                  {isLanguangeMenuVisible && (
                    <ul className="apollo-header-menu-sub">
                      {locales.map((lang, langIdx) => {
                        return (
                          <li
                            key={`lang_${langIdx}`}
                            className={`apollo-header-menu-sub-item ${
                              locale === lang.code ? 'active' : ''
                            }`}
                            onClick={this.onSwitchLocale}
                            data-code={lang.code}
                          >
                            {lang.name}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </li>
                {tbdFlags[29807] && (
                  <li className="apollo-header-menu-item">
                    <a href="/tube/preferenceSettings">
                      <span className="apollo-header-menu-icon">
                        <PreferenceIcon />
                      </span>
                      <FormattedMessage
                        id="SH_PersonalPreferences"
                        defaultMessage="個人偏好"
                      />
                    </a>
                  </li>
                )}
                <li className="apollo-header-menu-item">
                  <a href="#" onClick={this.handleLogout}>
                    <span className="apollo-header-menu-icon">
                      <PowerOffIconCmp />
                    </span>
                    <FormattedMessage id="SH_Logout" defaultMessage="登出" />
                  </a>
                </li>
              </HeaderDropDown>
            </div>
          )}
        </div>

        {this.state.shouldShowFIDO2Modal && (
          <Dialog
            title={
              <FormattedMessage
                id={FIDO_TERMS.TITLE.id}
                defaultMessage={FIDO_TERMS.TITLE.defaultMessage}
              />
            }
            onClose={() => this.setState({ shouldShowFIDO2Modal: false })}
            onConfirm={() => {
              this.handleRegisterFIDO2();
              this.setState({ shouldShowFIDO2Modal: false });
            }}
            size={'large'}
          >
            <div className="fido_introText">
              {FIDO_TERMS.CONTENT.map((term, index) => (
                <p key={index}>
                  <FormattedMessage
                    key={`term_${index}`}
                    id={term.id}
                    defaultMessage={term.defaultMessage}
                  />
                </p>
              ))}
            </div>
          </Dialog>
        )}
        {this.state.shouldShowFIDO2ResultModal && (
          <Dialog
            title={
              <FormattedMessage
                key="fido2ResultTitleId"
                id={this.state.fido2ResultTitleId}
                defaultMessage="裝置綁定失敗"
              />
            }
            onClose={() => this.setState({ shouldShowFIDO2ResultModal: false })}
            onConfirm={() => {
              this.setState({ shouldShowFIDO2ResultModal: false });
            }}
          >
            <div className="fido_resultMessage">
              <p>
                {
                  <FormattedMessage
                    key="1"
                    id={this.state.fido2ResultMessageId}
                    defaultMessage="裝置綁定失敗"
                  />
                }
              </p>
            </div>
          </Dialog>
        )}
      </header>
    );
  }
}

Header.propTypes = {
  history: PropTypes.object,
  userName: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
  isSidebarDisplay: PropTypes.bool.isRequired,
  onLinkClick: PropTypes.func,
  companyLogo: PropTypes.string.isRequired,
  personalPicture: PropTypes.string,
  permission: PropTypes.object,
  primaryColor: PropTypes.string,
  locales: PropTypes.array.isRequired,
  onSwitchLocale: PropTypes.func.isRequired,
  handleToggleSidebar: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  moduleAuth: PropTypes.array.isRequired,
  employeeNumber: PropTypes.string,
  companyCode: PropTypes.string,
};
Header.defaultProps = {
  userName: '',
};

class HeaderWithPermission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicPermissionsLoaded: false,
      permissionCache: null,
      lastPermissionCheck: {},
      apiPermissions: [], // 儲存從 API 獲取的權限數據
    };
    this.getAuthorizedFunctions = this.getAuthorizedFunctions.bind(this);
    this.transformAuthorizedFunctions =
      this.transformAuthorizedFunctions.bind(this);
  }

  componentDidMount() {
    // 獲取動態權限
    this.getAuthorizedFunctions();
  }

  // 獲取授權功能 API
  getAuthorizedFunctions() {
    var self = this;
    var apiUrl = url.NEWTUBE_API_SERVER + 'Authorization/GetAuthorized';

    return fetch(apiUrl)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.Data && Array.isArray(data.Data)) {
          var dynamicFunctionCodes = self.transformAuthorizedFunctions(
            data.Data
          );

          // 儲存 API 權限數據到 state
          self.setState({
            apiPermissions: data.Data,
            dynamicPermissionsLoaded: true,
          });

          // 更新權限配置
          self.updatePermissionConfig(dynamicFunctionCodes);
        } else {
          self.setState({ dynamicPermissionsLoaded: true });
        }
        return data;
      })
      .catch(function (error) {
        self.setState({ dynamicPermissionsLoaded: true });
        throw error;
      });
  }

  // 轉換授權功能數據格式
  transformAuthorizedFunctions(data) {
    return data.map(function (item) {
      return {
        functionCode: item.functionCode,
        actionCode: item.actionCode || 'Default',
      };
    });
  }

  // 更新權限配置
  updatePermissionConfig(dynamicFunctionCodes) {
    var self = this;

    // 基本權限
    var baseFunctionCodes = [
      { functionCode: 'PeopleSearch', actionCode: 'Default' },
      { functionCode: 'ChangePassword', actionCode: 'Default' },
    ];

    // 合併基本權限和動態權限
    var allFunctionCodes = baseFunctionCodes.concat(dynamicFunctionCodes);

    // 創建新的權限配置
    var newConfig = {
      permission: 'PeopleSearchHeader',
      functionCodes: allFunctionCodes,
      baseURL: url.NEWTUBE_API_SERVER,
    };

    // 重新初始化權限
    if (self.props.initialize) {
      self.props.initialize(newConfig);
    }

    // 重新創建頁面權限
    setTimeout(function () {
      if (self.props.createPagePermission) {
        self.props.createPagePermission('PeopleSearchHeader');
      }
    }, 100);
  }

  render() {
    // 攔截並處理 permission prop
    var interceptedProps = Object.assign({}, this.props);

    // 如果有 permission，可以在這裡進行攔截和修改
    if (interceptedProps.permission) {
      // 創建增強的 permission 物件
      var enhancedPermission = this.enhancePermission(
        interceptedProps.permission
      );
      interceptedProps.permission = enhancedPermission;
    }
    // 使用 API 數據創建新的 permission 物件
    if (interceptedProps.permission) {
      // 創建新的 permission 物件，直接使用 API 數據作為 functionCodes
      var newPermission = Object.assign({}, interceptedProps.permission, {
        functionCodes: this.state.apiPermissions.map(function (item) {
          return {
            functionCode: item.FunctionCode,
            actionCode: item.ActionCode,
          };
        }), // 直接使用 API 返回的資料
      });

      interceptedProps.permission = newPermission;
    }

    return <Header {...interceptedProps} />;
  }

  // 增強 permission 物件 - 專注於修改 functionCode
  enhancePermission(originalPermission) {
    var self = this;

    return Object.assign({}, originalPermission, {
      // 保留原有方法
      originalIsActionAllowed: originalPermission.isActionAllowed,

      // 覆寫 isActionAllowed 方法，主要修改 functionCode
      isActionAllowed: function (functionCodes, actionCode) {
        // 修改 functionCode 的邏輯
        var modifiedFunctionCodes = self.modifyFunctionCodes(functionCodes);

        // 使用修改後的 functionCode 進行權限檢查
        var result = originalPermission.isActionAllowed(
          modifiedFunctionCodes,
          actionCode
        );

        return result;
      },
    });
  }

  // 修改 functionCode 的邏輯 - 使用 API 數據
  modifyFunctionCodes(functionCodes) {
    var self = this;
    // 確保 functionCodes 是陣列
    var codes = Array.isArray(functionCodes) ? functionCodes : [functionCodes];

    // 使用 API 數據進行 functionCode 修改
    var modifiedCodes = codes.map(function (code) {
      // 檢查 API 數據中是否存在此 functionCode
      var apiPermission = self.findPermissionInAPI(code);

      if (apiPermission) {
        // 如果在 API 數據中找到，使用 API 中的 functionCode
        return apiPermission.FunctionCode;
      } else {
        // 如果在 API 數據中沒找到，檢查是否需要映射
        var mappedCode = self.mapFunctionCode(code);
        return mappedCode;
      }
    });

    // 如果原始輸入是字串，返回第一個元素；否則返回陣列
    return Array.isArray(functionCodes) ? modifiedCodes : modifiedCodes[0];
  }

  // 在 API 數據中查找權限
  findPermissionInAPI(functionCode) {
    return this.state.apiPermissions.find(function (permission) {
      return (
        permission.functionCode === functionCode ||
        permission.FunctionCode === functionCode ||
        permission.FunctionCode === functionCode.toLowerCase()
      );
    });
  }

  // 映射 functionCode 規則（當 API 中沒找到時的備用方案）
  mapFunctionCode(code) {
    // 這裡可以定義靜態映射規則
    var mappingRules = {
      // 範例：如果需要將某些權限碼映射到其他權限碼
      // 'OldFunctionCode': 'NewFunctionCode',
    };

    return mappingRules[code] || code; // 如果沒有映射規則，返回原始碼
  }
}

export default withPermission(permissionConfig)(HeaderWithPermission);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/Header/index.js
 **/